export enum Variants {
    bordered = 'bordered',
    plain = 'plain',
}
